import { AuthService as MockAuthService } from './auth.service.mock';
import { UserService as MockUserService } from './user.service.mock';
import { UserService } from '@app/services/user.service';
import { AuthService } from '@app/services/auth.service';
import { environment } from '@env/environment';
import { AdminUserService } from '@app/services/admin-user-service';
import { MockAdminUserService } from './admin-user-service.mock';
import { PermissionGroupService } from '@app/services/permission-group.service';
import { MockPermissionGroupService } from './permission-group.service.mock';
import { RoleService } from '@app/services/role.service';
import { MockRoleService } from './role.service.mock';
import { MockSettingService } from './setting.service.mock';
import { SettingService } from '@app/services/setting.service';

console.log('base environment: ', environment)

export const providers = environment.isMock ? [
  { provide: UserService, useClass: MockUserService },
  { provide: AdminUserService, useClass: MockAdminUserService },
  { provide: PermissionGroupService, useClass: MockPermissionGroupService },
  { provide: RoleService, useClass: MockRoleService },
  { provide: SettingService, useClass: MockSettingService },
  { provide: AuthService, useClass: MockAuthService }
] : []
